<template>
    <div id="produtos">
        <div class="produtos-chamada">
            <h3>nossos</h3>
            <h2>produtos</h2>
        </div>
        <div class="produtos">
            <div :class="p.classes" v-for="(p, index) in produtos" :key="index">
                <figure>
                    <img @click="show(p.slug)" :src="p.coverImage" alt="">
                </figure>
            </div>
        </div>

        <modal v-for="(p, index) in produtos"
            :key="index"
            :name="p.slug" 
            transition="nice-modal-fade"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            height="auto"
        >
            <div :class="p.classesModal" :style="{ backgroundColor: p.backgroundColor }">
                <div class="row">
                    <div class="col-md-4 produto-left">
                        <img :src="p.mainImage" alt="">
                    </div>
                    <div class="col-md-8 produto-right">
                        <div class="row">
                            <div class="col-md-12 produto-produtos">
                                <img :src="p.secondaryImage" alt="">
                            </div>
                            <div class="col-md-12 produto-tabela">
                                <img :src="p.table" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    data(){
        return {
            produtos: [
                {
                    slug: 'tubaina',
                    backgroundColor: '#f2cf01',
                    coverImage: require('../assets/produtos/thumbs/tubaina.png'),
                    mainImage: require('../assets/produtos/tubaina/produto_g.png'),
                    secondaryImage: require('../assets/produtos/tubaina/produto_p.png'),
                    table: require('../assets/produtos/tubaina/tabela.png'),
                    classes: 'thumb hover thumb2',
                    classesModal: 'produto'
                },
                {
                    slug: 'laranja',
                    backgroundColor: '#d25c2e',
                    coverImage: require('../assets/produtos/thumbs/laranja.png'),
                    mainImage: require('../assets/produtos/laranja/produto_g.png'),
                    secondaryImage: require('../assets/produtos/laranja/produto_p.png'),
                    table: require('../assets/produtos/laranja/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'limao',
                    backgroundColor: '#58a847',
                    coverImage: require('../assets/produtos/thumbs/limao.png'),
                    mainImage: require('../assets/produtos/limao/produtos_g.png'),
                    secondaryImage: require('../assets/produtos/limao/produtos_p.png'),
                    table: require('../assets/produtos/limao/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'citrus',
                    backgroundColor: '#c3de03',
                    coverImage: require('../assets/produtos/thumbs/citrus.png'),
                    mainImage: require('../assets/produtos/citrus/produto_g.png'),
                    secondaryImage: require('../assets/produtos/citrus/produto_p.png'),
                    table: require('../assets/produtos/citrus/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'uva',
                    backgroundColor: '#622165',
                    coverImage: require('../assets/produtos/thumbs/uva.png'),
                    mainImage: require('../assets/produtos/uva/produto_g.png'),
                    secondaryImage: require('../assets/produtos/uva/produto_p.png'),
                    table: require('../assets/produtos/uva/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'guarana',
                    backgroundColor: '#1a9f2c',
                    coverImage: require('../assets/produtos/thumbs/guarana.png'),
                    mainImage: require('../assets/produtos/guarana/produto_g.png'),
                    secondaryImage: require('../assets/produtos/guarana/produto_p.png'),
                    table: require('../assets/produtos/guarana/tabela.png'),
                    classes: 'thumb hover thumb2',
                    classesModal: 'produto'
                },
                {
                    slug: 'refricola',
                    backgroundColor: '#95010d',
                    coverImage: require('../assets/produtos/thumbs/refricola.png'),
                    mainImage: require('../assets/produtos/refricola/produto_g.png'),
                    secondaryImage: require('../assets/produtos/refricola/produto_p.png'),
                    table: require('../assets/produtos/refricola/tabela.png'),
                    classes: 'thumb hover thumb2',
                    classesModal: 'produto'
                },
                {
                    slug: 'tubaina-zero',
                    backgroundColor: '#fff',
                    coverImage: require('../assets/produtos/thumbs/tubaina-zero.png'),
                    mainImage: require('../assets/produtos/tubaina-zero/produto_g.png'),
                    secondaryImage: require('../assets/produtos/tubaina-zero/produto_p.png'),
                    table: require('../assets/produtos/tubaina-zero/tabela.png'),
                    classes: 'thumb hover thumb2',
                    classesModal: 'produto'
                },
                {
                    slug: 'guarana-zero',
                    backgroundColor: '#fff',
                    coverImage: require('../assets/produtos/thumbs/guarana-zero.png'),
                    mainImage: require('../assets/produtos/guarana-zero/produto_g.png'),
                    secondaryImage: require('../assets/produtos/guarana-zero/produto_p.png'),
                    table: require('../assets/produtos/guarana-zero/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'limao-zero',
                    backgroundColor: '#fff',
                    coverImage: require('../assets/produtos/thumbs/limao-zero.png'),
                    mainImage: require('../assets/produtos/limao-zero/produto_g.png'),
                    secondaryImage: require('../assets/produtos/limao-zero/produto_p.png'),
                    table: require('../assets/produtos/limao-zero/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'laranja-zero',
                    backgroundColor: '#fff',
                    coverImage: require('../assets/produtos/thumbs/laranja-zero.png'),
                    mainImage: require('../assets/produtos/laranja-zero/produto_g.png'),
                    secondaryImage: require('../assets/produtos/laranja-zero/produto_p.png'),
                    table: require('../assets/produtos/laranja-zero/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'retro',
                    backgroundColor: '#b62a19',
                    coverImage: require('../assets/produtos/thumbs/tubaina-retro.png'),
                    mainImage: require('../assets/produtos/tubaina-retro/produto_g.png'),
                    secondaryImage: require('../assets/produtos/tubaina-retro/produtos_p.png'),
                    table: require('../assets/produtos/tubaina-retro/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'frutuba_tubaina',
                    backgroundColor: '#263086',
                    coverImage: require('../assets/produtos/thumbs/frutuba-tubaina.png'),
                    mainImage: require('../assets/produtos/frutuba_tubaina/produto_g.png'),
                    secondaryImage: require('../assets/produtos/frutuba_tubaina/produto_p.png'),
                    table: require('../assets/produtos/frutuba_tubaina/tabela.png'),
                    classes: 'thumb thumb2 hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'frutuba_guarana',
                    backgroundColor: '#263086',
                    coverImage: require('../assets/produtos/thumbs/frutuba-guarana.png'),
                    mainImage: require('../assets/produtos/frutuba_guarana/produto_g.png'),
                    secondaryImage: require('../assets/produtos/frutuba_guarana/produto_p.png'),
                    table: require('../assets/produtos/frutuba_guarana/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'frutuba_limao',
                    backgroundColor: '#263086',
                    coverImage: require('../assets/produtos/thumbs/frutuba-limao.png'),
                    mainImage: require('../assets/produtos/frutuba_limao/produto_g.png'),
                    secondaryImage: require('../assets/produtos/frutuba_limao/produto_p.png'),
                    table: require('../assets/produtos/frutuba_limao/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'frutuba_laranja',
                    backgroundColor: '#263086',
                    coverImage: require('../assets/produtos/thumbs/frutuba-laranja.png'),
                    mainImage: require('../assets/produtos/frutuba_laranja/produto_g.png'),
                    secondaryImage: require('../assets/produtos/frutuba_laranja/produto_p.png'),
                    table: require('../assets/produtos/frutuba_laranja/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'rc',
                    backgroundColor: '#014fb1',
                    coverImage: require('../assets/produtos/thumbs/rccola.png'),
                    mainImage: require('../assets/produtos/rc/produto_g.png'),
                    secondaryImage: require('../assets/produtos/rc/produto_p.png'),
                    table: require('../assets/produtos/rc/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'oitosegundos',
                    backgroundColor: '#000',
                    coverImage: require('../assets/produtos/thumbs/8seg.png'),
                    mainImage: require('../assets/produtos/oitosegundos/produto_g.png'),
                    secondaryImage: require('../assets/produtos/oitosegundos/produto_p.png'),
                    table: require('../assets/produtos/oitosegundos/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'energy-drink',
                    backgroundColor: '#fff',
                    coverImage: require('../assets/produtos/thumbs/energy-drink.png'),
                    mainImage: require('../assets/produtos/energy-drink/produto_g.png'),
                    secondaryImage: require('../assets/produtos/energy-drink/produto_p.png'),
                    table: require('../assets/produtos/energy-drink/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'tonica',
                    backgroundColor: '#003794',
                    coverImage: require('../assets/produtos/thumbs/tonica.png'),
                    mainImage: require('../assets/produtos/tonica/produto_g.png'),
                    secondaryImage: require('../assets/produtos/tonica/produto_p.png'),
                    table: require('../assets/produtos/tonica/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto tonica'
                },
                {
                    slug: 'mate',
                    backgroundColor: '#879b53',
                    coverImage: require('../assets/produtos/thumbs/mate.png'),
                    mainImage: require('../assets/produtos/mate/produtos_g.png'),
                    secondaryImage: require('../assets/produtos/mate/produtos_p.png'),
                    table: require('../assets/produtos/mate/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'antares-sgas',
                    backgroundColor: '#2c90f0',
                    coverImage: require('../assets/produtos/thumbs/antares-sgas.png'),
                    mainImage: require('../assets/produtos/antares-sgas/produto_g.png'),
                    secondaryImage: require('../assets/produtos/antares-sgas/produto_p.png'),
                    table: require('../assets/produtos/antares-sgas/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'antares-cgas',
                    backgroundColor: '#2c90f0',
                    coverImage: require('../assets/produtos/thumbs/antares-cgas.png'),
                    mainImage: require('../assets/produtos/antares-cgas/produto_g.png'),
                    secondaryImage: require('../assets/produtos/antares-cgas/produto_p.png'),
                    table: require('../assets/produtos/antares-cgas/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'agua-coco',
                    backgroundColor: '#015b1b',
                    coverImage: require('../assets/produtos/thumbs/agua-coco.png'),
                    mainImage: require('../assets/produtos/agua-coco/produto_g.png'),
                    secondaryImage: require('../assets/produtos/agua-coco/produto_p.png'),
                    table: require('../assets/produtos/agua-coco/tabela.png'),
                    classes: 'thumb thumb2 hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'spremidos-uva',
                    backgroundColor: '#2e877d',
                    coverImage: require('../assets/produtos/thumbs/spremidos-uva.png'),
                    mainImage: require('../assets/produtos/spremidos-uva/produto_g.png'),
                    secondaryImage: require('../assets/produtos/spremidos-uva/produto_p.png'),
                    table: require('../assets/produtos/spremidos-uva/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                },
                {
                    slug: 'spremidos-citrus',
                    backgroundColor: '#50ab3b',
                    coverImage: require('../assets/produtos/thumbs/spremidos-citrus.png'),
                    mainImage: require('../assets/produtos/spremidos-citrus/produto_g.png'),
                    secondaryImage: require('../assets/produtos/spremidos-citrus/produto_p.png'),
                    table: require('../assets/produtos/spremidos-citrus/tabela.png'),
                    classes: 'thumb hover',
                    classesModal: 'produto'
                }
            ]
        }
    },
    methods: {
        show (name) {
            this.$modal.show(name);
        },
        hide (name) {
            this.$modal.hide(name);
        }
    },

    mounted: function() {
        // console.log(this.produtos)
    }
}
</script>


<style scoped>

.produto {
    width: 100%;
    height: 100%;
}

.produto-left {
    padding: 60px 20px 60px 20px;
    text-align: right;
}

.mini .row .produto-left {
    padding: 150px 0px !Important;
}

.tonica .row .produto-left {
    padding: 165px 0px !Important;
}

.produto-left img {
    width: 45%;
}

.produto-right {
    text-align: center;
    padding: 65px;
}

.produto-produtos {
    display: inline;
}

.produto-tabela {
    margin-top: 80px;
}

@media only screen and (min-width: 320px) and (max-width: 720px) {
    .produto {
    }

    .produto-produtos {
        
    }
    .produto-right {
        text-align: center;
        padding: 0px 35px 35px 35px;
    }
    .produto-left img {
        width: 38%;
    }

    .produto-left {
        padding: 20px 20px 0px 20px;
        text-align: center;
    }
}

* {
	box-sizing: border-box;
}

#produtos {
    background: #ededed;
}

.demo-modal-class {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  }

  .size-modal-content {
    padding: 10px;
    font-style: 13px;
  }
  .v--modal-overlay[data-modal="size-modal"] {
    background: rgba(0, 0, 0, 0.8);
  }

.produtos {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 50px 50px 50px 50px;
}

.container{
    width: 100%;
}

img {
	max-width: 100%;
}

.container {
	display: flex;
	flex-wrap: wrap;
	height: 100vh;
}

.thumb {
	/* border: 2px solid green; */
	flex: 1 1 25%;
	display: flex;
	align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
}

.thumb2 {
    flex: 1 1 50%;
}

.hover figure img {
	-webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .2s ease-in-out;
	transition: .2s ease-in-out;
}
.hover figure:hover img {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.produtos-chamada {
    padding-top: 50px;
    padding-left: 50px;
}

.produtos-chamada h2 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 15pt;
  text-transform: uppercase;
}

.produtos-chamada h3 {
  font-family: "Bambino";
  font-style: normal;
  font-size: 10pt;
  text-transform: uppercase;
  font-weight: 300;
}

figure {
    margin: -1px;
    
}

@media only screen and (min-width: 320px) and (max-width: 1024px) {

    .thumb {
        flex: 1 1 50%;
    }

    .thumb2 {
        flex: 1 1 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Produtos.vue